module.exports = __webpack_public_path__ + "static/media/sweating.0669795.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mp3/sweating.mp3
// module id = PTPL
// module chunks = 1 3